export default "__VITE_ASSET__cr_Qy46H__"